<div class="">
  <div class="container-fluid">
    <div class="col-md-12">
      <!-- <app-card-icon-title [icon]="iconEditMail"></app-card-icon-title> -->
      <!-- <hr /> -->
      <div class="d-flex align-items-center">
        <span>Probation Period (months):</span>

        <form
          *ngIf="showEdit; else showP"
          class="d-flex ml-3 align-items-center"
          action=""
        >
          <input
            class="form-control"
            type="number"
            placeholder="Probation Period"
            [(ngModel)]="probation"
            name="probation"
          />
          <div>
            <button
              class="ml-2 btn btn-info btn-md"
              *ngIf="!probation && !showEdit; else update"
              (click)="updateProbation()"
            >
              Set Probation Period
            </button>
            <ng-template #update>
              <button
                class="ml-2 btn btn-info btn-md"
                (click)="updateProbation()"
              >
                Update
              </button>
            </ng-template>
          </div>
        </form>
        <ng-template #showP>
          <span class="pl-2">{{ probation }}</span>
          <span *ngIf="probation == null" class="pl-2">0</span>
        </ng-template>

        <button
          class="btn btn-sm btn-link btn-danger btn-just-icon"
          (click)="showEdit = !showEdit"
        >
          <div>
            <i *ngIf="!showEdit; else close" class="fa fa-edit"></i>
            <ng-template #close>
              <i class="fa fa-times"></i>
            </ng-template>
          </div>
        </button>
      </div>

      <div class="d-flex align-items-center">
        <span>PTO Hours Increment Limit: </span>

        <form
          *ngIf="showEditPL; else showPL"
          class="d-flex ml-3 align-items-center"
          action=""
        >
          <select
            name="ptoHoursLimitForm"
            id="ptoHoursLimitForm"
            [(ngModel)]="ptoHoursLimit"
            class="form-control"
          >
            <option value="No Limit">No Limit</option>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
            <option value="9">9</option>
            <option value="10">10</option>
          </select>

          <div>
            <button
              class="ml-2 btn btn-info btn-md"
              *ngIf="!probation && !showEdit; else update"
              (click)="updatePTOHoursLimit()"
            >
              Set PTO Hours Limit
            </button>
            <ng-template #update>
              <button
                class="ml-2 btn btn-info btn-md"
                (click)="updatePTOHoursLimit()"
              >
                Update
              </button>
            </ng-template>
          </div>
        </form>
        <ng-template #showPL>
          <span class="pl-2">{{ ptoHoursLimit }}</span>
          <span *ngIf="ptoHoursLimit == null" class="pl-2">No Limit</span>
        </ng-template>

        <button
          class="btn btn-sm btn-link btn-danger btn-just-icon"
          (click)="showEditPL = !showEditPL"
        >
          <div>
            <i *ngIf="!showEditPL; else closePL" class="fa fa-edit"></i>
            <ng-template #closePL>
              <i class="fa fa-times"></i>
            </ng-template>
          </div>
        </button>
      </div>

      <div
        class="card-body col-md-10 d-flex justify-content-center pt-8 m-auto"
      >
        <!-- <loading *ngIf="loading"></loading>
        <div *ngIf="!loading"></div> -->
        <div
          class="d-flex flex-md-row flex-column justify-content-between mt-12"
        >
          <form
            class="responsive-form p-4 card"
            style="height: 230px"
            action=""
          >
            <h4>Add a Year of PTO</h4>
            <input
              class="form-control"
              type="number"
              placeholder="year"
              [(ngModel)]="year"
              name="year"
            />
            <input
              class="form-control mt-2"
              type="number"
              placeholder="Hours Per Year"
              [(ngModel)]="hours"
              name="hours"
            />
            <button class="mt-4 btn btn-success btn-md" (click)="createPto()">
              Add
            </button>
          </form>
          <div class="pt-4">
            <table class="table table-striped">
              <tr>
                <th>Length of Employment (years)</th>
                <th>Annual Accrued Hours of PTO</th>
                <th>Actions</th>
              </tr>
              <tr *ngFor="let item of list; let i = index">
                <td>
                  {{ item.year }}
                  <span *ngIf="i == list.length - 1">+</span>
                </td>
                <td>{{ item.hoursPto }} hrs per year</td>
                <td>
                  <button
                    class="btn btn-sm btn-link btn-danger btn-just-icon"
                    (click)="removePto(item.id)"
                  >
                    <i class="fa fa-trash"></i>
                  </button>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
